import React from 'react';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { useTeachers } from 'modules/courses/hooks';
import { isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import LoadMoreButton from '../load-more-button';
import TeacherCard from '../teacher-card';
import TeacherSkeleton from '../teacher-skeleton';

const TeachersList = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const type = useAppSelector(({ courses }) => courses.type);

  const { teachers, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useTeachers({
    search: query?.search as string,
    enabled: type === 'teachers'
  });

  return (
    <Visible
      if={isLoading}
      else={
        <Visible
          if={isEmptyArr(teachers)}
          else={
            <>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                {teachers?.map(teacher => (
                  <TeacherCard
                    url={teacher?.slug}
                    image={teacher?.image?.small}
                    name={teacher?.full_name}
                    specialty={teacher?.user_name}
                    key={teacher?.id}
                  />
                ))}

                {isFetchingNextPage &&
                  // eslint-disable-next-line react/no-array-index-key
                  Array.from({ length: 4 }).map((_, index) => <TeacherSkeleton key={index} />)}
              </div>

              {hasNextPage && <LoadMoreButton fetchNextPage={fetchNextPage} isFetchingNextPage={isFetchingNextPage} />}
            </>
          }
        >
          <EmptyData title={t('malumot_topilmadi')} />
        </Visible>
      }
    >
      <div className="grid grid-cols-4 gap-3">
        {Array.from({ length: 6 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <TeacherSkeleton key={index} />
        ))}
      </div>
    </Visible>
  );
};

export default TeachersList;
